<template lang="html">
  <div class="body1">
    <Info selfStyle="padding-left: 0;"/>
    <Reply selfStyle="padding-left: 0;"/>
  </div>
</template>

<script lang="js">
import Info from './Info.vue'
import Reply from './Reply.vue'
export default {
  components: {
    Info,
    Reply
  }
}
</script>

<style lang="scss" scoped>
.body1 {
  width: 66.666666%;
  background-color: #fff;
}
@media screen and (max-width: 768px) {
  .body {
    flex-direction: column;
    justify-content: center;
    .body1 {
      width: 100%;
    }
  }
}
</style>
